// extracted by mini-css-extract-plugin
export var chip = "_47-9";
export var chipLabel = "_47-a";
export var close = "_47-7";
export var closeIcon = "_47-8";
export var error = "_47-6";
export var infoTooltip = "_47-2";
export var innerContainer = "_47-1";
export var input = "_47-b";
export var medium = "_47-5";
export var outerContainer = "_47-0";
export var small = "_47-4";
export var xSmall = "_47-3";